export default __webpack_public_path__ + "static/media/timer-button-border.cf2e8372.png";